/**
 * useReportUser Hook
 * Mutation hook for submitting user reports
 */

import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { toast } from "sonner"
import type { ReportReason } from "@/services/report.service"
import { createCommentReport, createReport } from "@/services/report.service"

interface UseReportUserVariables {
  reportedUserId: string
  reason: ReportReason
  details?: string
  commentId?: string
}

export function useReportUser() {
  return useMutation({
    mutationFn: async (variables: UseReportUserVariables) => {
      if (variables.commentId) {
        return createCommentReport({
          commentId: variables.commentId,
          reason: variables.reason,
          details: variables.details,
        })
      }
      return createReport({
        reportedUserId: variables.reportedUserId,
        reason: variables.reason,
        details: variables.details,
      })
    },
    onError: (error: unknown) => {
      let message = "Failed to submit report"
      if (axios.isAxiosError(error)) {
        message = error.response?.data?.message || error.message
      } else if (error instanceof Error) {
        message = error.message
      }
      toast.error(message)
    },
  })
}
